module.exports = __webpack_public_path__ + "static/img/dian_yangan 2.425474ed.png";